import * as React from "react";
const SvgFr = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", x: "0px", y: "0px", viewBox: "0 0 512 512", style: {
  enableBackground: "new 0 0 512 512"
}, xmlSpace: "preserve", ...props }, /* @__PURE__ */ React.createElement("path", { style: {
  fill: "#41479B"
}, d: "M170.667,423.724H8.828c-4.875,0-8.828-3.953-8.828-8.828V97.103c0-4.875,3.953-8.828,8.828-8.828 h161.839V423.724z" }), /* @__PURE__ */ React.createElement("rect", { x: 170.67, y: 88.276, style: {
  fill: "#F5F5F5"
}, width: 170.67, height: 335.448 }), /* @__PURE__ */ React.createElement("path", { style: {
  fill: "#FF4B55"
}, d: "M503.172,423.724H341.333V88.276h161.839c4.875,0,8.828,3.953,8.828,8.828v317.793 C512,419.772,508.047,423.724,503.172,423.724z" }));
export default SvgFr;
